import { create } from 'zustand';

/**
 * The demo template a manager has explicitly opened to edit from Demo copies, or null. Held in memory only, never saved:
 * a reload, a new tab or a new sign-in lands them in their own copy again, so the template is never anyone's default.
 */
export const useTemplateEditStore = create<{ editing: string | null; start: (fundId: string) => void; stop: () => void }>()((set) => ({
  editing: null,
  start: (fundId) => set({ editing: fundId }),
  stop: () => set({ editing: null }),
}));
